export function checkIfIos() {
    const ua = window.navigator.userAgent.toLowerCase();
    const isOldIos = /iphone|ipad|ipod/.test(ua);
    const isNewIpad = ua.includes('macintosh') && 'ontouchend' in document;

    return isOldIos || isNewIpad;
}

export function isMobileDevice() {
    if (navigator.userAgentData) {
        return navigator.userAgentData.mobile;
    }

    const ua = navigator.userAgent;
    const isMobileUA = /Mobi|Android|iPhone|iPod/i.test(ua);
    const isAndroidTablet = /Android/i.test(ua) && !/Mobile/i.test(ua);
    const isIPad = /iPad/i.test(ua);
    const isIPadOS = ua.includes('Macintosh') && 'ontouchend' in document;

    return isMobileUA || isAndroidTablet || isIPad || isIPadOS;
}

export function isPWAInstalled() {
    return window.matchMedia('(display-mode: standalone)').matches ||
        window.navigator.standalone === true;
}

export function shouldSkipPWAInstallCheck() {
    const alreadyInstalled = window.matchMedia('(display-mode: standalone)').matches
    const installed = isPWAInstalled()

    return alreadyInstalled || !isMobileDevice() || installed
}

export async function installPWA({ deferredPrompt, onAccept, onDismiss, onCleanup }) {
    if (!deferredPrompt) return

    deferredPrompt.prompt()
    const { outcome } = await deferredPrompt.userChoice

    if (outcome === 'accepted') {
        console.log('User accepted the A2HS prompt')
        onAccept?.()
    } else {
        console.log('User dismissed the A2HS prompt')
        onDismiss?.()
    }

    onCleanup?.()
}
